import Cookies from "universal-cookie";

const cookies = new Cookies()
const prod = window.location.protocol === "https:"
const options = { path: "/", secure: prod, sameSite: "strict" as const }

export const keys = {
  access: "token_access",
  refresh: "token_refresh",
  expiry: "expires_at",
  user: "user",
  service: "app_service",
  company: "app_company",
  companies: "app_companies"
} as const

type CookieKey = keyof typeof keys
type CookieData = Partial<Record<CookieKey, any>>

export const getCookie = (key: CookieKey) => {
  return cookies.get(keys[key])
}

export const getCookies = (selected?: CookieKey[]) => {
  let list: CookieKey[] = selected ?? (Object.keys(keys) as CookieKey[])

  return list.reduce((accumulated, key) => {
    accumulated[key] = cookies.get(keys[key])
    return accumulated
  }, {} as Partial<Record<CookieKey, any>>)
}

export const setCookie = (key: CookieKey, value: any) => {
  cookies.set(keys[key], value, options)
}

export const setCookies = (data: CookieData) => {
  Object.entries(data).forEach(([key, value]) => {
    if (value !== undefined) {
      cookies.set(keys[key as CookieKey], value, options)
    }
  })
}

export const removeCookie = (key: CookieKey) => {
  cookies.remove(keys[key], { path: "/" })
}

export const removeCookies = (selected?: CookieKey[]) => {
  let list: CookieKey[] = selected ?? (Object.keys(keys) as CookieKey[])

  list.forEach((key) => {
    cookies.remove(keys[key], { path: "/" })
  })
}
